/* Mavula Seats — Theme JS */
(function () {
  'use strict';

  // Header — transparent only on pages with a full-bleed dark hero at the top.
  // All other pages (cart, collection, warranty, etc.) get dark header immediately.
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var hasHero = document.querySelector('.hero, .phero');
    var forceScrolled = !hasHero;

    var onScroll = function () {
      hdr.classList.toggle('scrolled', forceScrolled || window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run immediately
  }

  // Mobile drawer
  var menuBtn  = document.querySelector('.hdr__menu');
  var drawer   = document.querySelector('.drawer');
  var closeBtn = drawer && drawer.querySelector('.close');
  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', function () { drawer.classList.add('open'); });
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', function () { drawer.classList.remove('open'); });
  }
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.classList.remove('open'); });
    });
  }

  // Parallax images — [data-parallax="speed"] where speed is 0–50
  var parallaxEls = document.querySelectorAll('[data-parallax]');
  var noMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (parallaxEls.length && !noMotion) {
    var rafId;
    // Activate CSS class for images that have speed > 0
    parallaxEls.forEach(function (img) {
      if (parseFloat(img.dataset.parallax) > 0) img.classList.add('parallax-active');
    });
    function runParallax() {
      if (window.innerWidth < 768) return;
      parallaxEls.forEach(function (img) {
        var speed = parseFloat(img.dataset.parallax);
        if (!speed) return;
        var sec = img.closest('section');
        if (!sec) return;
        var rect = sec.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        // Normalise: 0 when section centred in viewport, ±1 at entry/exit edges
        var progress = (window.innerHeight / 2 - (rect.top + rect.height / 2)) / (window.innerHeight / 2 + rect.height / 2);
        var maxTravel = 40; // px
        var offset = progress * maxTravel * (speed / 30);
        img.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
      });
    }
    window.addEventListener('scroll', function () {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(runParallax);
    }, { passive: true });
    window.addEventListener('resize', runParallax, { passive: true });
    runParallax();
  }

  // Scroll-reveal — fade + rise elements into view
  var revealEls = document.querySelectorAll(
    '.eyebrow, h1, h2, h3, .sp-hero__lead, .btn, .rcard, .bpillars__col, ' +
    '.sp-values__card, .sp-origin__grid, .tbar__col, .phl__item'
  );
  if (revealEls.length && 'IntersectionObserver' in window) {
    revealEls.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity .55s ease ' + (i % 4) * 0.08 + 's, transform .55s ease ' + (i % 4) * 0.08 + 's';
    });
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          ro.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { ro.observe(el); });
  }

  // Smooth scroll for hash links
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
})();
